import styled from "styled-components";
import Image from "../Image";

export const Img = styled(Image)`
  border-radius: 50%;
  object-fit: cover;
  object-position: center;
  background-color: rgb(243, 244, 246);
  border: 1px solid rgb(196, 196, 196);
`;
